<template>
  <div class="bg-white q-pa-lg">
    <div class="row justify-between items-center q-mb-lg">
      <h6 class="q-ma-none text-weight-bold text-grey-9">Quotes</h6>
      <div class="row justify-end col-grow items-center q-gutter-x-md">
        <span class="text-weight-medium text-grey-8">Status</span>
        <QSelect
          class="col-6 col-sm-3 col-md-2"
          color="secondary"
          outlined
          dense
          v-model="quoteStatus"
          :options="statusOptions"
          option-label="name"
          :loading="$apollo.queries.dbQuoteStatuses.loading"
        />
      </div>
    </div>
    <QTable
      flat
      :loading="$apollo.queries.dbquotes.loading"
      :columns="columns"
      :data="dbquotes.rows"
      :pagination="pagination"
      @row-click="this.openQuote"
      @request="tableQuotesRequest"
      row-key="quoteRef"
    />
  </div>
</template>

<script>
import { QTable, QSelect } from 'eclipx.ui';
import quotesTableColumns from './quotesTableColumns';
import QueryQuotes from '../../graphql/queries/QueryQuotes';
import QueryQuoteStatuses from '../../graphql/queries/QueryQuoteStatuses';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';
import { mapMutations } from 'vuex';

export default {
  name: 'Quotes',
  data() {
    return {
      columns: quotesTableColumns,
      quoteStatus: { name: 'Show All', code: null },
      dbQuoteStatuses: [],
      dbquotes: {},
      sortBy: 'created_at',
      descending: true,
      page: 1,
      rowsPerPage: 20
    };
  },
  computed: {
    pagination: function() {
      return {
        sortBy: this.sortBy,
        descending: this.descending,
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        // Total number of records that can be requested
        rowsNumber: this.dbquotes.count
      };
    },
    statusOptions: function() {
      return [{ name: 'Show All', code: null }, ...this.dbQuoteStatuses];
    }
  },
  apollo: {
    dbQuoteStatuses: {
      query: QueryQuoteStatuses,
      variables: function() {
        return {
          orgId: this.$store.getters['auth/user'].organisation.id
        };
      },
      error: function() {
        this.$euiNotifications.emit({
          notification: GLOBAL_ERROR,
          action: () => {
            return this.$apollo.queries.dbQuoteStatuses.refresh();
          }
        });
      }
    },
    dbquotes: {
      query: QueryQuotes,
      fetchPolicy: 'network-only',
      variables() {
        return {
          params: {
            orgId: this.$store.getters['auth/user'].organisation.id,
            page: this.page - 1, // Quasar table is 1 based, the api is 0 based
            size: this.rowsPerPage,
            sortCol: this.sortBy,
            sortType: this.descending ? 'desc' : 'asc',
            filterCol: 'quote_status_code',
            filterOp: 'eq',
            filterValue: this.quoteStatus ? this.quoteStatus.code : null
          }
        };
      },
      error: function(error) {
        if (error) {
          this.$euiNotifications.emit({
            notification: GLOBAL_ERROR,
            action: () => {
              return this.$apollo.queries.dbquotes.refresh();
            }
          });
        }
      }
    }
  },
  methods: {
    ...mapMutations({ createNewQuote: 'quote/createNewQuote' }),
    openQuote: function(event, row) {
      this.$router.push({
        name: 'quoteReview',
        params: { quoteId: row.id }
      });
    },
    tableQuotesRequest: function({ pagination }) {
      this.sortBy = pagination.sortBy;
      this.descending = pagination.descending;
      this.page = pagination.page;
      this.rowsPerPage = pagination.rowsPerPage;

      // Ensure the data fields have been set before querying for the quotes list
      this.$nextTick(function() {
        this.$apollo.queries.dbquotes.refresh();
      });
    }
  },
  created() {
    this.createNewQuote();
  },
  components: {
    QTable,
    QSelect
  }
};
</script>
